const VISITOR_ID_NUM_MIN = 100000000;
const VISITOR_ID_NUM_MAX = 999999999;

export const VISITOR_ID_COOKIE_NAME = 'cpVisitorId';

export const isValidVisitorId = str => /^\d{9}[a-f0-9]{13}$/.test(str);

export const visitorIdInsidePercentile = (visitorId, min, max) => {
  const idNumberRange = VISITOR_ID_NUM_MAX - VISITOR_ID_NUM_MIN;
  const lowerBound = VISITOR_ID_NUM_MIN + Math.round(idNumberRange * min);
  const upperBound = VISITOR_ID_NUM_MIN + Math.round(idNumberRange * max);
  const intPartOfVisitorId = parseInt((visitorId || '').substr(0, 9), 10);
  return intPartOfVisitorId >= lowerBound && intPartOfVisitorId <= upperBound;
};

export const generateVisitorId = () => {
  const rand = (min, max) => Math.round(Math.random() * (max - min) + min);

  return [
    `${rand(VISITOR_ID_NUM_MIN, VISITOR_ID_NUM_MAX)}`,
    [
      rand(0x100000, 0xffffff).toString('16'),
      rand(0x100000, 0xffffff).toString('16'),
      rand(0x100000, 0xffffff).toString('16'),
    ]
      .join('')
      .substr(0, 13),
  ].join('');
};
